type CustomMenuTitleItemProps = {
  imageSrc?: string
  moduleName: string
  moduleLabel: string
}

export function CustomMenuTitleItem (props: CustomMenuTitleItemProps) {
  const { imageSrc, moduleName, moduleLabel } = props
  return (<>
    <li className="menu-title">
      <div className="flex gap-2 items-center mt-4">
        {imageSrc && (
          <img
            src={imageSrc}
            alt={`${moduleName}-logo`}
            className="size-7 rounded-md"
          />
        )}
        <span className="grow">{moduleLabel}</span>
      </div>
    </li>
  </>)
}
